import type { FunnelStep } from '@/types/analytics'

export const STEP_LABELS: Record<FunnelStep['step'], string> = {
  session: 'Sessions',
  product_view: 'Viewed a product',
  add_to_cart: 'Added to cart',
  checkout: 'Reached checkout',
  checkout_form: 'Started checkout form',
  payment: 'Placed order',
  purchase: 'Order confirmed',
}

export const titleClass = 'w-fit text-sm font-semibold underline decoration-faint decoration-dotted underline-offset-4'
